import { render, staticRenderFns } from "./ChannelSelector.vue?vue&type=template&id=1331847c"
import script from "./ChannelSelector.vue?vue&type=script&lang=js"
export * from "./ChannelSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports